import {getEndpointForSetUserHasSeenSeasonalBrandkit} from '@Libraries/seasonal-brandkit-popover.library';
import {getEndpointForGetUserHasSeenSeasonalBrandkit} from '@Libraries/seasonal-brandkit-popover.library';
import {useEffect, useState} from 'react';
import type {SeasonName} from '@Libraries/seasons.library';

export function useShowSeasonalBrandkitPopover(season: SeasonName | undefined): [boolean, () => Promise<void>] {
  const [showSeasonalBrandkitPopover, setShowSeasonalBrandkitPopover] = useState(false);

  useEffect(() => {
    if (!season) {
      return;
    }

    init();
  }, []);

  if (!season) {
    return [false, async (): Promise<void> => {}];
  }

  const getUserHasSeenSeasonalBrandkitPopover = async (): Promise<boolean> => {
    return !!(await window.PMW.readLocal(getEndpointForGetUserHasSeenSeasonalBrandkit(season)));
  };

  const markUserHasSeenSeasonalBrandkitPopover = async (): Promise<void> => {
    try {
      await window.PMW.readLocal(getEndpointForSetUserHasSeenSeasonalBrandkit(season));
    } catch (e) {
      console.error(`Error setting user has seen brandkit popover for ${season}. Details:`, e);
    }

    setShowSeasonalBrandkitPopover(false);
  };

  const initUserHasSeenSeasonalBrandkitPopoverStatus = async (): Promise<void> => {
    try {
      const response = await getUserHasSeenSeasonalBrandkitPopover();
      setShowSeasonalBrandkitPopover(!response);
    } catch (e) {
      setShowSeasonalBrandkitPopover(false);
    }
  };

  const init = (): void => {
    void initUserHasSeenSeasonalBrandkitPopoverStatus();
  };

  return [showSeasonalBrandkitPopover, markUserHasSeenSeasonalBrandkitPopover];
}
